import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import {useIntl} from 'react-intl'
import {ALL_KEY} from '../../../shared/constants'
import { BranchStatus } from '../constants'
import { BranchListFilterModel } from '../models/BranchListFilterModel'
import { filterDataChange, selectBranchFilter, setShowAddBranchModal } from '../redux/BranchRedux'
import AddBranchModal from './AddBranchModal'

type Props = {
  className?: string
}
const BranchTableFilter: FC<Props> = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const brandFilter: BranchListFilterModel = useAppSelector(selectBranchFilter)


  const handleSearchTextChanged = (e?: any | undefined) => {
    if (e) {
      const value = e.target.value
      dispatch(filterDataChange({...brandFilter, name: value, page: 1}))
    } else {
      dispatch(filterDataChange({...brandFilter, name: undefined, page: 1}))
    }
  }
  const handleBrandStatusChanged = (e: any) => {
    const value = e.target.value
    if (value !== '0') {
      dispatch(filterDataChange({...brandFilter, status: value, page: 1}))
    } else {
      dispatch(filterDataChange({...brandFilter, status: undefined, page: 1}))
    }
  }

  return (
    <div className='card-header border-0 pt-3'>
      <div className='d-flex align-items-center'>
        <div className='d-flex align-items-center position-relative me-4'>
          <span className='position-absolute cursor-pointer ms-3' onClick={handleSearchTextChanged}>
            <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-3' />
          </span>
          <input
            type='text'
            id='kt_filter_search'
            className='form-control form-control-white form-control-sm w-150px ps-9'
            placeholder='Search'
            onChange={handleSearchTextChanged}
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                handleSearchTextChanged()
              }
            }}
          />
        </div>
        <div className='d-flex my-2'>
          <select
            name='status'
            data-hide-search='true'
            className='form-select form-select-white form-select-sm w-125px me-4'
            defaultValue={0}
            onChange={handleBrandStatusChanged}
          >
            <option value={ALL_KEY}>{intl.formatMessage({id: 'SYSTEM.ALL'})}</option>
            {Object.keys(BranchStatus).map((item: any) => (
              <option key={item} value={item}>
                {intl.formatMessage({id: 'BRANCH.STATUS.' + item.toUpperCase()})}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className='card-toolbar'>
        <button
          onClick={() => dispatch(setShowAddBranchModal(true))}
          className='btn btn-sm btn-primary'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
          {intl.formatMessage({id: 'SYSTEM.ADD_NEW'})}
        </button>
      </div>
      <AddBranchModal />
    </div>
  )
}
export default BranchTableFilter
